/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from './styles';
import LocalCatalogo from '~/components/LocalCatalogo';
import imgContato from '~/assets/foto-contato.jpg';
import FooterContato from '~/components/FooterContato';
import api from '../../services/api';
import { set } from 'date-fns';

function Contato() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [assunto, setAssunto] = useState('');
  const [assuntoError, setAssuntoError] = useState('');
  const [duvida, setDuvida] = useState('');
  const [duvidaError, setDuvidaError] = useState('');

  let messageNameError = '';
  let messageEmailError = '';
  let messageAssuntoError = '';
  let messageDuvidaError = '';
  
  let name_clear = document.querySelector('.name-clear');
  let email_clear = document.querySelector('.email-clear');
  let assunto_clear = document.querySelector('.assunto-clear');
  let mensagem_clear = document.querySelector('.mensagem-clear');

  if(name.length > 0 && name.length < 3) {
    messageNameError = <div className="validation-inputs size-font-error text-danger">Mínimo 3 caracteres!</div>
    if(name_clear != undefined || name_clear != null ){
      name_clear.innerHTML = ''
      name_clear.classList.remove('name-clear')
    }
  }
  if(email.length !== 0){
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 0 && email.length < 7) {
      messageEmailError = <div className="validation-inputs size-font-error text-danger">E-mail deve conter "@" e "." e ter no mínimo 7 caracteres</div>
      if(email_clear != undefined || email_clear != null){
        email_clear.innerHTML = ''
        email_clear.classList.remove('email-clear')
      }
    }
  }
  if(assunto.length > 0 && assunto.length < 5) {
    messageAssuntoError = <div className="validation-inputs size-font-error text-danger">Mínimo 5 caracteres!</div>
    if(assunto_clear != undefined || assunto_clear != null){
      assunto_clear.innerHTML = ''
      assunto_clear.classList.remove('assunto-clear')
    }
  }
  if(duvida.length > 0 && duvida.length < 10) {
    messageDuvidaError = <div className="validation-inputs size-font-error text-danger">Mínimo 10 caracteres!</div>
    if(mensagem_clear != undefined || mensagem_clear != null){
      mensagem_clear.innerHTML = ''
      mensagem_clear.classList.remove('mensagem-clear')
    }
  }

  let button;
  if (loading) {
    button = (
      <div className="btn mb-2">
        <div className="loader" />
      </div>
    );
  } else {
    button = (
      <button type="submit" className="btn mb-2" >
        Enviar
      </button>
    );
  }
  
  const handleSubmit = async event => {
    setLoading(true);
    event.preventDefault();
     
      const form = event.target;
      const formData = new FormData(form);
      const response = await api.post('/contato', formData);
      setLoading(false);
      form.reset();
      if (response.status === 200) {
        const resultado = response.data.split("-");
        if(resultado[0] === 'E'){
          const messageDiv = (
            <div className="alert alert-success">Mensagem enviada com sucesso!</div>
          );
          setName('');
          setEmail('');
          setAssunto('');
          setDuvida('');
          setMessage(messageDiv);
          
        }else{
          const messageDiv = (
            <div className="alert alert-danger">Erro ao enviar a mensagem!</div>
          );
          setMessage(messageDiv);
          const existErrorName = resultado.includes('Nome obrigatório')
          const existErrorEmail = resultado.includes('Email obrigatório')
          const existErrorAssunto = resultado.includes('Assunto obrigatório')
          const existErrorMensagem = resultado.includes('Mensagem obrigatório')
          if(existErrorName){
            setNameError('')
            messageNameError = (
              <div className="validation-inputs text-danger mb-1 size-font-error name-clear">Nome obrigatório</div>
            )
            setNameError(messageNameError)
          }else{
            setNameError('')
          }
          if(existErrorEmail){
            setEmailError('')
            messageEmailError = (
              <div className="validation-inputs text-danger mb-1 size-font-error email-clear">Email obrigatório</div>
            )
            setEmailError(messageEmailError)
          }else{
            setEmailError('')
          }
          
          if(existErrorAssunto){
            setAssuntoError('')
            messageAssuntoError = (
              <div className="validation-inputs text-danger mb-1 size-font-error assunto-clear">Assunto obrigatório</div>
            )
            setAssuntoError(messageAssuntoError)
          }else{
            setAssuntoError('')
          }
          
          if(existErrorMensagem){
            messageDuvidaError = (
              <div className="validation-inputs text-danger mb-1 size-font-error mensagem-clear">Mensagem obrigatório</div>
            )
            setDuvidaError(messageDuvidaError)
          }else{
            setDuvidaError('')
          }
        }
      }
  };
  return (
    <>
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Anaconda Cosméticos – Contato</title>
          <meta
            name="description"
            content="Ficou com alguma dúvida, precisa de atendimento? Mande mensagem e fale conosco!"
          />
        </Helmet>
        <div className="row-100 banner-contatos">
          <div className="container text-right">
            <h1 className="mr-5">FALE CONOSCO!</h1>
          </div>
        </div>
        <div className="row-100 my-4">
          <div className="container d-flex">
            <img
              src={imgContato}
              alt="Imagem contato"
              className="col-5 border border-secondary p-0 desk-only"
            />

            <div className="col-7 p-4 mobile-form">
              <h2 className="h3 font-weight-bold">Mande uma mensagem!</h2>
              <form
                onSubmit={handleSubmit}
                id="form-contato"
                encType="multipart/form-data"
              >
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control  mb-1"
                    id="nome"
                    placeholder="Digite seu nome *"
                    name="nome"
                    // required
                    onChange={(e)=> setName(e.target.value)}
                    value={name}
                  />
                  {messageNameError}
                  {nameError}
                  
                </div>
                <div className="form-group ">
                  <input
                    type="email"
                    className="form-control mt-4 mb-1"
                    id="email"
                    placeholder="Seu email *"
                    name="email"
                    // required
                    onChange={(e)=> setEmail(e.target.value)}
                    value={email}
                  />
                {messageEmailError}
                {emailError}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control mt-4 mb-1"
                    id="assunto"
                    placeholder="Qual o assunto? *"
                    name="assunto"
                    // required
                    onChange={(e)=> setAssunto(e.target.value)}
                    
                    value={assunto}
                  />
                {messageAssuntoError}
                {assuntoError}
                </div>

                <div className="form-group">
                  <textarea
                    className="form-control mt-4 mb-1"
                    id="duvida"
                    rows="3"
                    placeholder="Qual é a sua dúvida? * "
                    name="mensagem"
                    // required
                    onChange={(e)=> setDuvida(e.target.value)}
                    value={duvida}
                  />
                  {messageDuvidaError}
                  {duvidaError}
                </div>
                <div className="mb-2">
                    <small className='mb-1'>
                      * Campos obrigatórios
                    </small>
                  </div>
                {button}
              </form>
              {message}
            </div>
          </div>
        </div>
        <LocalCatalogo />
        <FooterContato />
      </Container>
    </>
  );
}

export default Contato;
